import { useCallback, memo } from 'react';
import type { ChangeEvent, ComponentProps } from 'react';
import { SearchField } from 'components/common/SearchField';
import { trackQuickSearch } from 'utils/posthog/metrics';

type Props = ComponentProps<typeof SearchField> & {
  area: 'listing' | 'detail_subsection' | 'detail' | string;
  agendaId?: string;
  viewId?: string;
};

const TrackedSearchFieldBase = ({ area, agendaId, viewId, onChange, ...rest }: Props) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      try {
        const value = e?.target?.value ?? '';
        trackQuickSearch({ area, agendaId, viewId, process: area, query: String(value) });
      } catch {
        /* noop */
      }
      onChange?.(e);
    },
    [agendaId, viewId, area, onChange]
  );

  return <SearchField {...rest} onChange={handleChange} />;
};

export const TrackedSearchField = memo(TrackedSearchFieldBase) as typeof TrackedSearchFieldBase;
